import { mountRaceList } from './utils/mount-race-list.js';
import { STATE_URL } from './constants.js';

// Statewide offices, in this order: Lt. Governor, Secretary of State,
// Controller, Treasurer, Attorney General, Insurance Commissioner,
// Superintendent of Public Instruction
mountRaceList('ca-statewide-races', STATE_URL, {
  filter: { offices: ['L', 'SS', 'C', 'T', 'A', 'CI', 'SUE'], sort: 'offices' },
  component: 'result',
}).catch(console.error);
